module.exports = __webpack_public_path__ + "static/cashew_nuts_tieu_xanh_4-7facf064cf8d4e9d5471c081d93930bc.jpg";